import { render, staticRenderFns } from "./StagingSectionValueEditor.vue?vue&type=template&id=51fe371f"
import script from "./StagingSectionValueEditor.vue?vue&type=script&lang=ts"
export * from "./StagingSectionValueEditor.vue?vue&type=script&lang=ts"
import style0 from "./StagingSectionValueEditor.vue?vue&type=style&index=0&id=51fe371f&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports